import Cookies from 'js-cookie'
import { getPageConfig } from 'api/common'
import { setting } from '@/setting'
import { domainConfig } from '@/setting/ywWork/domainConfig'
import { h5SignUrl } from 'api/config'
const { baseInfo } = setting
const app = {
  state: {
    sidebar: {
      opened: !+Cookies.get('sidebarStatus'),
      withoutAnimation: false
    },
    device: 'desktop',
    pageConfig: {
      showRightTool: true,
      logoUrl: '',
      copyright: '',
      favicon: ''
    }
  },
  mutations: {
    // 设置网站配置信息
    SET_PAGE_CONFIG: (state, pageConfig) => {
      state.pageConfig = pageConfig
    },
    TOGGLE_SIDEBAR: (state) => {
      if (state.sidebar.opened) {
        Cookies.set('sidebarStatus', 1)
      } else {
        Cookies.set('sidebarStatus', 0)
      }
      state.sidebar.opened = !state.sidebar.opened
      state.sidebar.withoutAnimation = false
    },
    CLOSE_SIDEBAR: (state, withoutAnimation) => {
      Cookies.set('sidebarStatus', 1)
      state.sidebar.opened = false
      state.sidebar.withoutAnimation = withoutAnimation
    },
    TOGGLE_DEVICE: (state, device) => {
      state.device = device
    }
  },
  actions: {
    getPageConfig: async ({ commit }) => {
      const defaultConfig = {
        logoUrl: baseInfo.logo,
        copyright: baseInfo.copyright,
        pathname: '/',
        title: baseInfo.name,
        favicon: baseInfo.favicon,
        beian: baseInfo.beian,
        h5SignUrl: h5SignUrl
      }

      const applyFavicon = (favicon) => {
        if (!favicon) return
        const link =
          document.querySelector("link[rel*='icon']") ||
          document.createElement('link')
        link.type = 'image/x-icon'
        link.rel = 'shortcut icon'
        link.href = favicon
        document.getElementsByTagName('head')[0].appendChild(link)
      }

      // 优先：域名匹配（支持精确域名和 *.example.com 通配子域名）
      const hostname = window.location.hostname
      const matchedDomainConfig = Object.entries(domainConfig).find(([key]) => {
        if (key.startsWith('*.')) {
          const baseDomain = key.slice(2)
          return hostname === baseDomain || hostname.endsWith('.' + baseDomain)
        }
        return hostname === key
      })
      if (matchedDomainConfig) {
        const matched = matchedDomainConfig[1]
        commit('SET_PAGE_CONFIG', {
          ...defaultConfig,
          ...matched,
          isCustom: true
        })
        document.title = matched.title
        applyFavicon(matched.favicon)
        return
      }

      // 降级：路径后缀匹配（原有逻辑）
      const pathname = window.location.pathname
        .replace(/#(.*?)$/, '')
        .split('/')
        .filter((item) => item)
      const env = process.env.VUE_APP_RUNTIME
      if (
        (env === 'production' || env === 'test') &&
        /zhongxin|viktor|xkd/g.test(pathname[0])
      ) {
        getPageConfig(pathname[0])
          .then(({ data }) => {
            data.pathname = pathname[0]
            commit('SET_PAGE_CONFIG', {
              ...defaultConfig,
              ...data,
              isCustom: true
            })
            document.title = data.title || baseInfo.name
            applyFavicon(data.favicon)
          })
          .catch()
      } else {
        commit('SET_PAGE_CONFIG', {
          showRightTool: true,
          ...defaultConfig
        })
        document.title = baseInfo.name
      }
    },
    ToggleSideBar: ({ commit }) => {
      commit('TOGGLE_SIDEBAR')
    },
    CloseSideBar({ commit }, { withoutAnimation }) {
      commit('CLOSE_SIDEBAR', withoutAnimation)
    },
    ToggleDevice({ commit }, device) {
      commit('TOGGLE_DEVICE', device)
    }
  }
}

export default app
